"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
class TokenService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.getPaymentOauthTokenUrl = '/rest-api/payment/oauth/v1/accessToken';
        this.getAutopayPaymentToken = '/rest-api/payment/oauth/v2/accessToken';
        this.errorMsgUrl = '/resources/json/mma/tokenserviceerrormessage.json';
        this.getOauthTokenUrl = '/rest-api/token/v1/login-status/';
    }
    // Oauth token service
    getOauthAccessToken() {
        return this.get(this.getPaymentOauthTokenUrl).pipe(operators_1.map((data) => data));
    }
    // Payment Token Service
    getPaymentToken(content, header, paymentUrl) {
        return this.post(paymentUrl, content, true, header).pipe(operators_1.map((data) => data));
    }
    getCreditCardRequest(payment, address, amountToPay) {
        const expMon = parseInt(payment.expirationMonth, 10);
        const expirationYear = parseInt(payment.expirationYear, 10);
        const creditCardTokenReq = {
            clientName: 'MMA',
            card: {
                firstName: address.firstName,
                lastName: address.lastName,
                cardNumber: payment.creditCardNumber,
                expMonth: expMon,
                expYear: expirationYear,
                address: address.address1,
                zipCode: address.zip,
                cvv: payment.cvv,
                amount: amountToPay,
                cardDataCaptureMethod: 'Manual',
                isGiftCard: false
            }
        };
        return creditCardTokenReq;
    }
    getGiftCardRequest(giftCardNumber) {
        const giftCardTokenReq = {
            clientName: 'MMA',
            card: {
                cardNumber: giftCardNumber,
                amount: 0,
                cardDataCaptureMethod: 'Manual',
                isGiftCard: true
            }
        };
        return giftCardTokenReq;
    }
    getCardType(content) {
        const cardRegExp = {
            Visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
            Master: /^5[1-5][0-9]{14}$/,
            Amex: /^3[47][0-9]{13}$/,
            Discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
        };
        for (const key in cardRegExp) {
            if (cardRegExp[key].test(content)) {
                return key;
            }
        }
    }
    getSICardType(content) {
        const re = {
            Visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
            Master: /^[52][0-9]{15}$/,
            Amex: /^3[0-9]{14}$/,
            Discover: /^6[0-9]{15}$/,
        };
        for (const key in re) {
            if (re[key].test(content)) {
                return key;
            }
        }
    }
    getCSErrorMessage() {
        return this.get(this.errorMsgUrl).pipe(operators_1.map((data) => data));
    }
    refreshToken() {
        return this.get(this.getOauthTokenUrl).pipe(operators_1.map((res) => res));
    }
    getDisplayCardType(creditType) {
        let creditTypeDisplay = null;
        creditType = creditType.toUpperCase();
        if (creditType != null) {
            if (creditType === 'AMEX' || creditType === 'AMERICANEXPRESS' || creditType === 'AMERICAN_EXPRESS') {
                creditTypeDisplay = 'American Express';
            }
            else if (creditType === 'MASTER' || creditType === 'MASTERCARD' || creditType === 'MASTER_CARD') {
                creditTypeDisplay = 'MasterCard';
            }
            else if (creditType === 'VISA') {
                creditTypeDisplay = 'Visa';
            }
            else if (creditType === 'DISCOVER') {
                creditTypeDisplay = 'Discover';
            }
            else {
                creditTypeDisplay = null;
            }
            creditTypeDisplay = creditTypeDisplay !== null ? creditTypeDisplay : creditType;
        }
        return creditTypeDisplay;
    }
}
exports.TokenService = TokenService;
//# sourceMappingURL=token.service.js.map